import { render } from "./accordion_Uikit.vue?vue&type=template&id=20331197"
import script from "./accordion_Uikit.vue?vue&type=script&lang=js"
export * from "./accordion_Uikit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__